import LocalizedStrings from 'react-localization';

export const strings = new LocalizedStrings({
  en: {
    displayText: {
      close: 'Close',
      emptyText: '',
      passwordsDoNotMatch: 'Passwords do not match',
      confirmYourPassword: 'Confirm your password',
      passwordMustBeNineErrText: 'Password must be at least 9 characters',
      passwordRegexValidationText:
        'Password should contain uppercase, lowercase, number, and symbol',
      expiredResetLinkError: 'This password reset link has expired or has already been used. Please request a new reset link.',
      orderPlacedText: 'Your Order has been placed successfully!',
      bankFileUploadText: 'Your bank file data was added successfully!',
      salesOrderText: 'Sales order Unit created successfully!',
      orderPlacedSizeFailedText:
        'Order size 0 is not valid. Please enter size greater than 0.',
      orderPlacedFailedText: 'Order Placed Failed',
      placeOrder: 'Place Order',
      placing: 'Placing....',
      orderPlaced: 'Order Placed!',
      passwordMustValidationText: 'Password must be entered',
      passwordUpdateSucessText: 'Password Updated Successfully!',
      setUpPasswordText: 'Set up password to login',
      invalidPasswordText: 'Login failed. Invalid credentials.',
      invalidSignatureText: 'invalid signature',
      invalidEmailOrPasswordText: 'Invalid Email or Password',
      detailsUpdatedSuccussfully: 'Details Updated Successfully!',
      fundId: 'Fund ID',
      fundName: 'Fund Name',
      dailyFee: 'Daily Fee',
      symbolAndContractId: ' Symbol & ContractId',
      totalContribution: 'Total Contribution',
      placeAndPreviewOrder: '  Place & Preview Order',
      planId: 'Plan Id',
      orderMethod: 'Order Method',
      unit: 'Unit',
      NotHoldingsThere: 'Currently This User Dont Have Holdings!',
      currentUnits: 'Current Units',
      transactionId: 'transactionId',
      userId: 'User ID',
      transactionDate: 'Transaction Date',
      transactionStatus: 'Transaction Status',
      amount: 'amount',
      amountLabel: 'Amount',
      weHaveSentOtp: 'We have sent a code to',
      pleaseEnterOtp: 'Please enter the code to continue',
      notreceiveOtp: 'Didn`t receive?',
      resendOtp: 'Resend Code',
      verifyOtp: 'Verify Code',
      emailOtp: 'Email Code',
      phoneOtp: 'Phone Code',
      sentOtptoEmailAndPhone: 'We have sent a code to Email and Phone',
      pleaseEnterCode: 'Please Enter the code to verify your account',
      accountVerified: 'Account verified successfully!',

      fileName: 'File Name',
      uploadDate: 'Upload Date',
      bankFileUploadDate: 'Bank File Upload Date',
      userID: 'User ID',
      todayOrder: 'Buy Order',
      userWiserContribution: 'Contribution by User',
      planWiseContribution: 'Contribution by Plan',
      orderHistory: 'Order History',
      orderConfirmAgain: 'Please Confirm Again',
      planName: 'Plan Name',
      cancelled: 'Cancelled',
      id: 'ID',
      orderType: ' Order Type',
      orderPlacedDate: ' Order Placed Date',
      orderValue: ' Order Value',
      orderResponse: 'Order Response',
      allocationStatus: 'Allocation Status',
      pendingAllocation: 'Pending Allocation',
      allocated: 'Allocated',
      retriggerOrder: 'Re-Order',
      salesOrder: 'Sell Order',
      emailValidateText: 'Enter a valid email address',
      emailMustText: 'Email address must be entered',
      emailExistTest: 'Email address already exists',
      emailNotRegisteredText: 'Email address is not registered as a user',
      invalidEmailText: 'Invalid email address',
      emailEmptyText: 'Email address is required',
      notPlacedLabel: "Not placed",
      mmOrderId: 'ZP Order ID',
      ibOrderId: 'IB Order ID',
      orderStatus: 'Order Status',
      totalUnits: 'Total Units',
      orderDate: 'Order Date',
      tradeDate: 'Trade Date',
      reAllocatedDate: 'Re-Allocated Date',
      filledDate: 'Filled Date',
      fundType: 'Fund Type',
      contractId: 'Contract ID',
      orderId: 'Order ID',
      symbol: 'Symbol',
      averagePrice: 'Average Price',
      tradePrice: 'Trade Price',
      closePrice: 'Close Price',
      currentPrice: 'Current Price',
      transactionMethod: 'Transaction Method',
      smartInvest: 'Smarter investment starts here',
      welcometoMarshmallow: 'Welcome to Zen Pensions',
      login: 'Login',
      forgotPassword: 'Forgot Password ?',
      pleaseEnterEmail:
        'Please enter the email address associated with your account',
      requestResetLink: 'Request reset link',
      signIn: 'Sign in',
      emailLabel: 'Email Address',
      passwordLabel: 'Password',
      noRows: 'No Rows',
      setYourPassword: 'Set your password',
      passwrdContainMsg:
        'Password must be of at least 9 characters and should contain uppercase, lowercase, number and symbol',
      continueText: 'Continue',
      uploadButton: 'Upload File',
      banFilesTitle: 'Bank Files',
      downloadBtn: 'Download',
      downloadFile: 'Download File',
      totalAllocatedUnits: 'Total Allocated Units',
      PendingSubmit:
        'Indicates the order was sent, but confirmation has not been received that it has been received by the destination. Occurs most commonly if an exchange is closed.',
      PendingCancel:
        'Indicates that a request has been sent to cancel an order but confirmation has not been received of its cancellation',
      PreSubmitted:
        'Indicates that a simulated order type has been accepted by the IBKR system and that this order has yet to be elected. The order is held in the IBKR system until the election criteria are met. At that time the order is transmitted to the order destination as specified',
      Cancelled:
        'Indicates that the balance of the order has been confirmed cancelled by the IB system. This could occur unexpectedly when IB or the destination has rejected the order.',
      Submitted:
        'Indicates that the order has been accepted at the order destination and is working.',
      Filled: ' Indicates that the order has been completely filled.',
      Inactive:
        'Indicates the order is not working, for instance if the order was invalid and triggered an error message, or if the order was to short a security and shares have not yet been located.',

      nameRequiredText: 'The Name is required',
      firstNameRequiredText: 'First Name is required',
      lastNameRequiredText: 'Last Name is required',
      complaintTitleRequiredText: 'Complaint title is required',
      complaintCreatedText: 'Complaint created successfully!',
      desccriptionRequiredText: 'Description is required',
      customerIdRequiredText: 'Customer ID is required!',
      phoneNumberRequiredText: 'Phone number is required',
      phoneNumberIsInvalid: 'Phone number is invalid',
      userCreatedSuccessText: 'User Created Successfully!',
      employerCreatedSuccessText: 'Employer Created Successfully!',
      employerUpdatedSuccessText: 'Employer Updated Successfully!',
      userUpdatedSuccessText: 'User Updated Successfully!',
      adminCreatedSuccessText: 'Admin Created Successfully!',
      adminUpdatedSuccessText: 'Admin Updated Successfully!',
      resetLinkSuccessText: 'Reset link sent successfully!',
      onBoardApprovedSuccessText: 'Verified successfully!',
      avcApprovedSuccessText: 'AVC declaration approved successfully!',
      onboardingRejectionReasonTitle: 'Onboarding rejection reason',
      avcRejectionReasonTitle: 'Declaration (AVC) rejection reason',
      otpSentSuccessText: 'Code sent successfully!',
      otpVerifiedSuccessText: 'Code Verification Successful!',
      loginSuccesText: 'Login Successful!',
      unknownErrorText: 'Unknown Error!',
      admin: 'admin',
      deleteSuccess: 'Successfully Deleted!',
      updateSuccess: 'Successfully Deleted!',
      organizationAdmin: 'organization_admin',
      organizationEmployee: 'organization_employee',
      deleteConfirmationText: 'Are you sure you want to delete the',
      deleteConfirmationBAdminText:
        'Are you sure you want to delete the employer',
      deleteConfirmationBAdminTextNew: 'Are you sure you want to delete the admin',
      updateActiveStatus: 'Are you sure you want to {status} the user?',
      reRegisterConfirmationText: ' Are you sure you want to register?',
      approveConfirmationText: ' Are you sure you want to approve?',
      leavingThisPageText: 'Leaving this page now will discard all entered information.',
      areYouSureYouWantToLeaveText: ' Are you sure you want to leave?',
      allowDigitsOnlyText: 'Please enter digits only',
      adminSuspendedMessage: 'The admin is Leaver.',
      employeeIdRequiredText: 'Employee ID is required',
      employeeContributionRequiredText: 'Empoyee Contribution Required',
      employerContributionRequiredText: 'Empoyer Contribution Required',
      roleRequiredText: 'Role or Designation is required',
      deparmentRequiredText: 'Deparment is required',
      noCommentsProvid: ' No comments are provided',
      locationRequiredText: 'Location is required',
      startDateRequiredText: 'Start Date is required',
      endDateRequiredText: 'End Date is required',
      referenceNoRequiredText: 'Reference No is required',
      amountRequiredText: 'Amount is required',
      employeeCreatedSuccessText: 'Employee Created Successfully!',
      employeeUpdatedSuccessText: 'Employee Updated Successfully!',
      organizationDeleteRestrictText: 'Not allowed to delete the Employer',
      adminStatusChange: 'Admin changed as ',
      EmployerStatusChange: 'employer is ', // active / inactive
      exportComplaintSuccess: 'Complaints Exported Successfully!',
      onlyYourAssinedCmpl: 'You can only see your complaint!',
      noPermissionToSeeOnBoradRequet: 'You do not have permission to view this onboarding request',
      onboardingSectionTitle: 'Partial Replacement',
      fundingLimitCheckDeclarationSectionTitle: 'AVC',
      noDocumentsUploaded: 'No documents uploaded',
      noNotesYet: 'No notes',
      sectionNotesHeading: 'Notes',
      onlyYourCmplStatus: 'You can change status your complaint only!',
      exportFundDetailsSuccess: 'Fund Details were successfully exported',
      deleteAlertMessage:
        'Unable to delete this admin. At least one admin is needed',
      cannotDeleteAdmin: 'Cannot delete admin please add one admin!',
      confirmStartDate: 'Confirm Start Date',
      confirmText: 'Confirm',
      chatCreatedText: 'Bulk chat sent successfully!',
      documentType: 'Documents Type',
      photos: 'Photos',
      profilePicture: 'Profile Picture',
      fullName: 'Full Name',
      emailAddress: 'Email Address',
      phoneNumber: 'Phone Number',
      gender: 'Gender',
      maritalStatus: 'Marital Status',
      economicStatus: 'Economic Status',
      economicOccupation: 'Economic Occupation',
      countryOfBirth: 'Country Of Birth',
      citizenship: 'Residency',
      dateOfBirth: 'Date Of Birth',
      address: 'Address',
      employmentStatus: 'Employment Status',
      ppsn: 'PPSN',
      totalAmount: 'Total Pot',
      withdrawalPercentage: 'Withdrawal Percentage',
      withdrawalAmount: 'Withdrawal Amount',
      status: 'Status',
      sepactReference: 'SEPA CT Reference',
      sepactReferenceError: 'SEPA CT Reference field cannot be empty!',
      withdrawalAmountError: 'Withdrawal amount field cannot be empty!',
      comments: 'Comments',
      commentsError: 'Comments field cannot be empty!',
      validation: 'Validation',
      bankDetails: 'Bank Details',
      minimumAge: 'Minimum age (60yrs)',
      validateSuccess: 'Validated',
      validateFailed: 'Validation failed',
      maxPercentagePension: 'Max % of pension eligible for withdrawal (25%)',
      amlCurrent: 'AML current',
      Attachment: 'Attachments',
      skipMMUnitOrders: 'Skip ZP Unit Orders',
      runDailyFeeCalculation: 'Run Daily Charge Calculation',
      runMonthlyFeeCalculation: 'Run Monthly Charge Calculation',
      runUnitAllocationJob: 'Run Unit Allocation Job',
      verify: 'Verify',
      notVerify: 'Not Verify',
      fundsToBePaids: 'Bank account setup/verified',
      onfidoVerificationStatus: 'Onfido verification status',
      stepNotComplete: 'Step not complete (not done)',
      rejected: 'Rejected',
      reject: 'Reject',
      approved: 'Approved',
      chat: 'Chat',
      singleDot: '-',
      amlCurrentDetails: 'Identity and Address Verification Docs',
      feeCalculationTitle: 'Charge Calculation',
      dailyFeeCalculationTitle: 'Daily Charge Calculation',
      monthlyFeeCalculationTitle: 'Monthly Charge Calculation',
      idColumn: 'ID',
      transacationId: 'Transaction ID',
      requestId: 'Request ID',
      transfersId: 'Transfers ID',
      planChangeRequestId: 'Request ID',
      withdrawRequestId: 'WithdrawRequest ID',
      bankFileId: 'Bank File ID',
      contributionId: 'Contribution ID',
      fundDetailsFundNameColumn: 'Fund Name',
      fundDetailsFundTotalUnitsColumn: 'Total Units',
      fundDetailsSymbolColumn: 'Symbol & ContractId',
      fundDetailsUnitsValueColumn: 'Value Of The Fund',
      fundDetailsClientUnitsColumn: 'Clients Units',
      fundDetailsMMUnitsColumn: 'ZP Units',
      pepTypeRequiredText: 'PEP Type is  required',
      duplicateEmailError: "Duplicate email detected in the list. Each email address must be unique",
      duplicatePhoneError: "Duplicate phone number detected in the list. Each phone number must be unique",

      totalUnitsAllocated: 'Total Units Allocated',
      contributedAmount: 'Contributed amount',
      pricePerUnit: 'Price per unit',
      percentageAllocation: 'Percentage Allocation',
      email: 'Email',
      firstName: 'First Name',
      lastName: 'Last Name',
      name: 'Name',
      View: 'View',
      registration: 'Registration',
      createdByAcorn: 'Created By Acorn',

      transactionDetailsOrderTypeColumn: 'Order Type',
      transactionDetailsTotalContributionColumn: 'Total Contribution',
      transactionDetailsStatusColumn: 'Status',
      transactionDetailsDateColumn: 'Transaction Date',
      userWiseContributionUserIdColumn: 'User ID',
      userWiseContributionUserNameColumn: 'User Name',
      userWiseContributionTotalColumn: 'Total',
      planWiseContributionPlanNameColumn: 'Plan Name',
      planWiseContributionContributionColumn: 'Contribution',
      send: 'Send',
      createChatComplaint: 'Create chat as complaint:',
      imageView: 'Image View',
      complaintDetails: 'Complaint Details',
      typeAMessage: 'Type a message',
      makeAComplaint: 'Mark as Complaint',
      search: 'Search',
      searchPlanName: 'Search Plan Name',
      complaintId: 'Complaint ID',
      invalidEmailFormat: 'Invalid email format',
      emailIsRequired: 'Email is required',

      customerDetails: 'Customer Details',
      customersId: 'Customer ID',
      dashboardTab: 'Dashboard',
      personalDetailsTab: 'Personal details',
      lifetimeGoalTab: 'Lifetime goals',
      planDetailsTab: 'Plan details',
      paymentsTab: 'Payments',
      transactionsTab: 'Transactions',
      pensionAggregateTab: 'Pension aggregate',
      chatsTab: 'Chats',
      DocumentsTab: 'Documents',
      complaintsRaisedTab: 'Complaints raised',
      holdings: 'Holdings',
      monthlyHoldings: 'Monthly Holdings',
      contributionHistory: 'History',
      contributionDetails: 'Contribution Details',

      totalContributionInFile: 'Total contribution in file',

      filter: 'Filter',
      monthlyCharge: 'Monthly Charge',
      orderDetails: 'Orders - Detailed',
      orderSummary: 'Orders - Summary',
      orderSummaryClientLevel: 'Orders - CLIENT LEVEL',
      contributionFileTotal: 'Contribution File Total',
      contributionFileTotalER: 'ER Contribution File €',
      contribution: 'Contribution',
      contributionSalesProceeds: 'Client Contrib’n (Buy)/Sales Proceeds (Sell)',
      submittedLabel: 'Submitted',
      cancelledLabel: 'Cancelled',
      pendingLabel: 'PendingSubmit',
      preSubmittedLabel: 'PreSubmitted',
      filledLabel: 'Filled',
      all: 'All',
      buy: 'BUY',
      sell: 'SELL',
      clear: 'CLEAR',
      contributionReceived: 'CONTRIBUTION RECEIVED',
      transferInReceived: 'TRANSFER IN RECEIVED',
      dateColumn: 'Date',
      allocatedDate: 'Allocation Date',
      complaintIdColumn: 'Complaint ID',
      nameColumn: 'Name',
      requestedDate: 'Requested Date',
      titleColumn: 'Title',
      descriptionColumn: 'Description',
      assignColumn: 'Assign',
      statusColumn: 'Status',
      actionsColumn: 'Actions',
      reOpenLable: 'Re-open',
      closeLable: 'Close',
      createComplaintText: 'Create Complaints',
      employeeDetailText: 'Employees details',
      monthColumn: 'Month',
      settlementDate: 'Settlement Date',
      paymentsEmptyText: 'There are no payment details available',
      paymentsTitle: 'Payment Details',
      bankNameLabel: 'Bank Name',
      debitAccountNameLabel: 'Debit Account Name',
      debitDateLabel: 'Debit Date',
      debitIbanLabel: 'Debit Iban',
      initialDepositLabel: 'Initial Deposit',
      monthlyTopUpLabel: 'Monthly TopUp',
      oneTimeTopUpLabel: 'One Time TopUp',
      paymentMethodsLabel: 'Payment Methods',
      contributionPeriod: 'Contribution Period',
      pensionEmptyText: 'There are no pension details available',
      activePensionTitle: 'Active pension plans',
      inactivepensionTitle: 'Inactive pension plans',
      pensionNameLabel: 'Pension Name',
      accountNumberLabel: 'Account Number',
      employerNameLabel: 'Employer Name',
      potSizeLabel: 'Pot Size',
      pensionCompanyLabel: 'Pension Company',

      desigination: 'Designation/Role',
      department: 'Department',
      location: 'Location',
      employeeID: 'Employee ID',
      employeeName: 'Employee Name',
      employerId: 'Employer ID',
      pensionPlanLabel: 'Pension Plan',
      retirementPlanLabel: "Retirement Option",
      transStartDate: 'Transaction Start Date',
      transEndDate: 'Transaction End Date',
      allocationStartDate: 'Allocation Start Date',
      allocationEndDate: 'Allocation End Date',
      filledStartDate: 'Filled Start Date',
      filledEndDate: 'Filled End Date',
      orderStartDate: 'Order Start Date',
      orderEndDate: 'Order End Date',
      settleStartDate: 'Settlement Start Date',
      settleEndDate: 'Settlement End Date',
      startDate: 'Start Date',
      endDate: 'End Date',
      employersID: 'Employers ID',
      existingRetirementOption: 'Existing Retirement Option',
      newRetirementOption: 'New Retirement Option',
      existingPensionPlan: 'Existing Pension Plan',
      newPensionPlan: 'New Pension Plan',
      planChangeRequestsLabel: 'Plan Change Requests',
      withdrawalRequestsLabel: 'Withdrawal Requests',
      planChangeRequestsApprovedDate: 'Approved Date',
      planChangeRequestsrejectDate: 'Rejected Date',
      planChangeRequestsOrderPlacedDate: 'Order Placed Date',

      referralsEmptyText: 'There are no Referrals',
      transcationEmptyText: 'There are no transaction details available',
      allocationAmount: 'Allocation Amount',
      fund: 'Fund',
      unitsAllocated: 'Units Allocated',

      companyName: 'Company Name',
      periodType: 'Period Type',
      frequencyType: 'Frequency Type',
      registerEmail: ' Registered Email',
      registerPhone: 'Registered Phone',
      registerAddress: 'Registered Address',
      noOfAdmins: 'No. of Admins',
      active: 'Active',
      uniqueId: 'Unique ID',
      fileId: 'File ID',
      dateOfFileUpload: 'Date of File Uploaded',
      dateOfFileDeleted: 'Date of File Deleted',
      deletedBy: 'Deleted By',
      deletedAt: 'Deleted At',
      isemailVerified: 'Is Email Verified?',
      sortingServer: 'server',
      editUser: 'Edit User',
      userDeleteSuccess: 'User Deleted Successfully!',
      userDeleteFailed: 'User Delete Failed!',
      employeeDeleteSuccessfully: 'Employee Deleted Successfully!',
      employeeDeleteFailed: 'Employee Delete Failed!',
      emailSubscriptionTitle: 'Email subscription',
      subscribed: 'Subscribed',
      unsubscribed: 'Unsubscribed',
      resendInvite: 'Resend Invite',
      invite: 'Invite',
      completedText: 'Completed',
      processingText: 'Processing',
      closedText: 'Closed',
      createEmployee: 'Create Employee',
      editEmployee: 'Edit Employee',
      editAdmin: 'Edit Admin',
      createAdmin: 'Create Admin',
      uploadFile: 'Upload File',
      downloadFormat: 'Download format',
      uploadData: 'Upload Data',
      upload: 'Upload',
      addEmployeeModelTitle: 'Please choose one of the following options',
      uploadSucessfull: 'Upload Successful!',
      uploadFailed: 'Upload Failed!',
      tryAgain: 'Try Again',
      notifications: 'Notifications',
      intiveSentSuccess: 'Invite sent successfully',
      intiveSentFailed: 'Invite sent failed',
      companyNameLabel: 'Company Name *',
      payrollFrequencyLabel: 'Payroll Frequency *',
      payroll: 'Payroll Frequency',
      payrollDateLabel: 'Payroll Date',
      registerEmailLabel: 'Registered Email *',
      registerPhoneNoLabel: 'Registered Phone No *',
      registerPhoneNoLabelWithoutStart: 'Registered Phone No',
      registerAddressLabel: 'Registered Address *',
      registerStreetOneLabel: 'Registered Street One',
      registerStreetTwoLabel: 'Registered Street Two',
      registerStreetThreeLabel: 'Registered Street Three',
      registerCityLabel: 'City',
      registerStateLabel: 'State',
      registerCountryLabel: 'Country *',
      registerEircodeLabel: 'Eircode *',
      registerCreatedByAcornLabel: 'Created By Acorn',
      sameAsAboveLabel: 'Trading information is the same as registered information',
      tradingEmailLabel: 'Trading Email *',
      tradingPhoneNoLabel: 'Trading Phone No *',
      tradingPhoneNoLabelWithoutStar: 'Trading Phone No',
      tradingAddressLabel: 'Trading Address *',
      tradingStreetOneLabel: 'Trading Street One',
      tradingStreetTwoLabel: 'Trading Street Two',
      tradingStreetThreeLabel: 'Trading Street Three',
      tradingcityLabel: 'City',
      tradingStateLabel: 'State',
      tradingCountryLabel: 'Country *',
      tradingEircodeLabel: 'Eircode *',
      addNowText: 'Add now',
      laterText: 'Later',
      addAnotherAdminText: 'Add another admin',
      saveText: 'Save',
      adminDetailsText: 'Admin Details',
      employerTaxDetails: 'Employer Tax Details *',
      employerTaxDetailsLabel: 'Employer Tax Details',
      employerBankAccountName: 'Employer Bank Account Name *',
      employerBankAccountNumber: 'Employer Bank Account Number *',
      payrollDate: 'Payroll Date *',
      approve: 'Approve',
      decline: 'Decline',
      cancel: 'Cancel',
      approver: 'Approver',
      auditor: 'Auditor',
      withdrawalDetail: 'Withdrawal Details',
      new: 'New',
      inProgress: 'In Progress',
      itemsPerPage: 'Items Per Page',
      add: 'Add',
      addNew: '+ Add New',
      uploadErrorMessage:
        'Every Month after 15th and before 28th for the next month (Except for th month of Feb, the last date would be 26th)',
      uploadSuccessMessage: 'Contribution Upload Successfully!',
      uploadFailedMessage: 'Contribution Upload Failed!',
      uploadFileDeleteFailedMessage: 'Contribution File Delete Failed',
      notificationSucessMessage: 'Notify successfully',
      notificationFailedMessage: 'Notify failed',
      employerContribution: 'Employer Contribution',
      employeeContribution: 'Employee Contribution',
      employerContributionPercentage: 'Employer Contribution Percentage',
      employeeContributionPercentage: 'Employee Contribution Percentage',
      employeeContributionPercent: 'Employee Contribution %',
      employerContributionPercent: 'Employer Contribution %',
      deleteEntryLabel: 'delete an entry',
      addEmpoyeeLabel: 'Add Employee',
      notifyLabel: 'Notify',
      removeLabel: 'Remove',
      fileNameLabel: 'File Name',
      organizationId: 'Organization ID',
      periodlabel: 'Period',
      periodDate: 'Period Date',
      dateUploadLabel: 'Date of Upload',
      uploadedByLabel: 'Uploaded By',
      contributionMessage:
        'The contributions are to be made after 15th and before 28th for the succeeding month except for the month of February in which case, the last date would be 26th',
      uploadContributionLabel: 'Upload Contribution',
      totalContributionLabel: 'Total Contribution',
      upcomingContributionLabel: 'Pending Contribution',
      dueDateLabel: 'Due Date',
      downloadLabel: 'download',
      archivesTitle: 'Archives',
      lastTenContributionText: 'Last 10 contributions',
      customDatesText: 'Custom Dates',
      startDateLabel: 'Start Date',
      endDateLabel: 'End Date',
      startDateFileUploadLabel: 'Start Date of File Upload',
      endDateFileUploadLabel: 'End Date of File Upload',
      resetLabel: 'Reset',
      submitLabel: 'Submit',
      contributionsforText: 'Contributions for',
      uploadBankFile: 'Upload Bank File',
      uploadBankFiles: 'Upload Bank Files',
      uploadEmployee: 'Upload Employee',
      uploadCustomerBankFile: 'Upload Customer`s Bank File',
      uploadEmployeeBankfile: ' Upload Employee Bank file',
      submitBtn: 'Submit',
      yearText: 'Year',
      contributionFormatText: 'Upload Contribution Format',
      downloadFormatLabel: 'Download format',
      okText: 'Ok',
      fileNotUplaod: 'File could not be uploaded',
      uploadAgainText: 'Upload Again',
      notifyEmployeeTitle: 'Notify employee',
      removeEntryTitle: 'Remove entry',
      unableToDeleteEmployeeText: 'Unable to delete employee',
      complaintTitle: 'Complaint Title',
      complaintDescription: ' Complaint Description',
      Send: 'Send',
      chatInputLabel: 'Type a message',
      resendLinkText: 'You can resend reset link in',
      requestResendLink: 'Request reset link',
      export: 'Export',
      contributionFileDetails: 'Contribution File Details',
      orderPendingEmployee: 'Order Pending for this employee',
      createdByAcornText: 'Created by Acorn',

      reOpen: 'Reopen',
      reOpenText: 'Re-Open',
      chatsText: 'Chats',
      chatSearchLabel: 'Search by Name or User ID',
      searchLabel: 'Search by Name, ID, Email or Phone Number...',
      searchLabel1: 'Search by Name, Email or Phone Number...',
      searchLabel2: 'Search by Name or ID...',
      searchLabel3: 'Search by Name, ID or Email...',
      searchLabel4: 'Search by Fund Name, Contract or Symbol...',
      searchLabel5: 'Search by Fund Name...',
      searchLabel6: 'Search by Name, ID, Title or Description...',
      searchLabel7: 'Search by File Name...',
      searchLabel8: 'Search by Creditor Name, Narrative or Reference...',
      searchLabel9: 'Search by Name or Email Address...',
      searchLabel10: 'Search by Fund Name, Fund ID, Fund Type, or Symbol',
      searchLabel11: 'Search by Name, ID or Date',
      searchLabel12: 'Search by Document Name...',
      addChat: 'Add Chat',
      bulkChat: 'Bulk Chat',
      createChatTitle: 'Create Chat',
      bulkChatTitle: 'Bulk Chat',
      employeeSuccessMessage: 'Employee Deleted Successfully!',
      employeeFailedMessage: 'Employee Delete Failed!',
      employeeAddSuccessMessage: 'Employees Added Successfully!',
      employeeReRegisterSuccessMessage:
        'Employee Re-Registration Successfully',
      employeeReRegisterFailedMessage: 'Employee Re-Registration Failed',

      confrimToDelete: 'Are you sure you want to delete this record?',
      delete: 'Delete',
      deleted: 'Deleted',
      succesfullyDelete: 'Deleted Successfully!',
      contributions: 'contributions',
      contributionsLabel: 'Contributions',
      pensionProvider: 'Pension Provider',
      pensionProviderBankAccountName: 'Pension Provider Bank Account Name',
      estimatedTransferValue: 'Estimated Transfer Value',
      contributionEmployer: 'Contribution Employer',
      ContributionEmployee: 'Contribution Employee',
      avclabel: 'AVC PRSA',
      avcStatus: 'AVC PRSA Status',
      identityVerified: 'Identity Verified',
      addressVerified: 'Address Verified',
      onfidoRegistration: 'Onfido Registration',
      onfidoRegistrationSuccess:
        'Onfido verification has been registered for this user.',
      onfidoRegistrationError:
        'Could not register Onfido verification. Please try again.',
      registerLabel: 'Register',
      pepWatchlistHit: 'PEP Watchlist Hit',
      sanctionsWatchlistHit: 'Sanctions Watchlist Hit',
      legalWatchlistHit: 'Legal Watchlist Hit',
      approveAvc: 'Approve AVC',
      rejectAvc: 'Reject AVC',
      fullPartialDeclaration: 'Full/Partial Replacement',
      fullPartialDeclarationStatus: 'Full/Partial Replacement Status',
      previousTransfer: 'Previous Transfer',
      sourceOfTransfer: 'Source of Transfer',
      dateTransferAmountreconciled: 'Date Transfer Amount reconciled',
      transactionType: 'Transaction Type',
      amountEuro: 'Amount',
      units: 'Units',
      charges: 'CHARGES',
      reAllocation: 'RE-ALLOCATION',
      contributionAdjustment: 'ADJUSTMENT',
      customerEmail: 'Customer Email',
      noUnitsAllocated: 'No units allocated for this order',
      transferValueReceived: 'Transfer Value Received',
      planApprovedSuccessMessage: 'Plan Change Request Approved Successfully!',
      errorMessage: 'Something went wrong',
      planRejectedSuccessMessage: 'Plan Change Request Rejected Successfully!',
      noOfRegisteredUser: 'Registered Users',
      noOfUnRegisteredUser: 'Not Registered Users',
      noOfUserNotContributed: 'Not Contributed Users',
      noOfUserContributed: 'Contributed Users',

      withdrawalRequestApproved: 'Withdrawal Request Approved Successfully!',
      withdrawalRequestRejected: 'Withdrawal Request Rejected!',
      withdrawalRequestClosed: 'Withdrawal Request Closed Successfully!',
      contributionDataExportSuccess: 'Contribution Data Exported Successfully!',
      contributionDataExportFailed: 'Error in Exporting contribution data!',
      orderHistoryExportSuccess: 'Order History Exported Successfully!',
      orderHistoryExportFail: 'Error in Exporting Order History!',
      orderDetailsExportSuccess: 'Order Details Exported Successfully!',
      orderDetailsExportFail: 'Error in Exporting Order Details!',
      reAllocationDataExportSuccess: 'Re-Allocation Data Exported Successfully!',
      reAllocationDataExportFail: 'Error in Exporting Re-Allocation Data!',
      orderSummaryExportSuccess: 'Order Summary Exported Successfully!',
      orderSummaryExportFail: 'Error in Exporting Order Summary!',
      buyOrderReportExportSuccess: 'Buy Order Report Exported Successfully!',
      buyOrderReportExportFailed: 'Error in Exporting Buy Order Report!',
      sellOrderReportExportSuccess: 'Sell Order Report Exported Successfully!',
      sellOrderReportExportFailed: 'Error in Exporting Sell Order Report!',
      bankFileReportExportSuccess: 'Bank File Report Exported Successfully!',
      bankFileReportExportFailed: 'Error in Exporting Bank File Report!',
      currentHoldingsReportExportSuccess: 'Current Holdings Report Exported Successfully!',
      currentHoldingsReportExportFailed: 'Error in Exporting Current Holdings Report!',
      monthlyHoldingsReportExportSuccess: 'Monthly Holdings Report Exported Successfully!',
      monthlyHoldingsReportExportFailed: 'Error in Exporting Monthly Holdings Report!',
      pepReportExportSuccess: 'PEP report Exported Successfully!',
      pepReportExportfailed: 'Error in Exporting PEP Report!',


      eruo: '€',
      accountName: 'Account Name',
      IBAN: 'IBAN',
      bankName: 'Bank Name',
      pensionPlan: 'Pension Plan',
      retirementOption: 'Retirement Option',
      userPlan: 'User Plan',
      userName: 'User Name',
      vested: 'Account Vested',
      vestedPrsaStatus: 'Vested PRSA Status',
      vestedPrsa: 'Vested PRSA',
      nonVestedPrsa: 'Not Vested',
      avc: 'AVC',
      employeerNameEmptyText: 'Employeers name is required',
      selectEmployers: 'Select Employers',
      allEmployers: 'All Employers',
      message: 'Message',
      proofOfAddress: 'Proof of Address',
      month: 'Month',
      week: 'Week',
      fortnight: 'Fortnight',
      transactionReference: 'Transaction Reference',
      transactionNarrative: 'Transaction Narrative',
      bankFileName: 'Bank File Name',
      debtorName: ' Debtor Name',
      creditorName: 'Creditor Name',
      creditOrDebit: 'Credit / Debit',
      credit: 'Credit',
      debit: 'Debit',
      reconciled: 'Reconciled',
      nonReconciled: 'Non Reconciled',
      nonReconciledPending: 'Non Recon - P',
      nonReconciledRejected: 'Non Recon - R',
      editTransactionNarrative: 'Edit Transaction Narrative',
      areYouConfirm: 'Are you sure you want to confirm?',
      transactionMarkedSuccessfully: 'Transaction marked successfully',
      statusMarkingError: 'Error occurred during marking transaction status',
      pepTypeText: 'Politically Exposed Person*',
      pepText: 'Politically Exposed Person',
      transactionOut: 'Transaction Out',
      transferOut: 'Transfer Out',
      transferIn: ' Transfer In',
      editTransferIn: 'Edit Transfer In',
      transferInUpdatedSuccessfully: 'Transfer In Request Updated Successfully!',
      update: 'Update',
      buyZpUnits: 'BUY ZP UNITS',
      noUserDataFound: 'No user data found',
      enterEmailOrCustomer: 'Enter Email ID or Customer ID',
      transferOutSuccessfully: 'Units Transfered Out Successfully!',
      fund1: 'Fund 1',
      fund2: 'Fund 2',
      fund3: 'Fund 3',
      fund4: 'Fund 4',
      fund5: 'Fund 5',
      fund6: 'Fund 6',
      totalFund1: 'Total Fund 1',
      totalFund2: 'Total Fund 2',
      totalFund3: 'Total Fund 3',
      totalFund4: 'Total Fund 4',
      totalFund5: 'Total Fund 5',
      totalFund6: 'Total Fund 6',
      bankFileRecordsReport: 'Bank File Record Report',
      totalContributionAmount: 'Total Contribution Amount',
      fillCompanyName: 'Please Fill Company name',
      fillPayrollFrequency: 'Please fill Payroll Frequency ',
      fillRegEmail: 'Please fill Registered Email',
      fillRegPhone: 'Please fill Registered Phone number',
      invalidRegPhone: 'Registered Phone Number should be of 9 digits',
      fillCountry: 'Please fill Country',
      fillPostalCode: 'Please fill Eircode ',
      fillTradingEmail: 'Please fill Trading Email ',
      fillTradingPhone: 'Please fill Trading Phone Number ',
      invalidTradingPhone: 'Trading Phone Number should be of 9 digits',
      fillMandatoryFields: 'Please fill all the Mandatory * fields',
      fillEconomicStatus: 'Kindly fill the Economic Status',
      fillEconomicOccupation: 'Kindly fill the Economic Occupation',
      fillPhoneNumber: 'Kindly fill the Phone Number',
      fillDob: 'Kindly fill the Date Of Birth',
      fillPepType: 'Kindly fill PEP Type',
      fillEmployerTaxDetails: 'Please fill Employer Tax Details',
      fillEmployerBankAccountName: 'Please fill Employer Bank Account Name',
      fillEmployerBankAccountNumber: 'Please fill Employer Bank Account Number',
      employerBankAccountNumberFormatCheck: 'Please check the format of Bank Account Number!',
      fillPayrollDate: 'Please fill Payroll Date',
      mandatoryFields: 'Mandatory * fields',
      fundValue1: 'fund1',
      fundValue2: 'fund2',
      fundValue3: 'fund3',
      fundValue4: 'fund4',
      fundValue5: 'fund5',
      fundValue6: 'cash',
      fund1Units: 'Fund 1 Units',
      fund2Units: 'Fund 2 Units',
      fund3Units: 'Fund 3 Units',
      fund4Units: 'Fund 4 Units',
      fund5Units: 'Fund 5 Units',
      fund6Units: 'Fund 6 Units',
      type: 'Type',
      total: 'Total',
      dailyFundPriceTitle: 'Daily Fund Price',
      dateExceeded: 'The date range for export cannot be more than 60 days',
      selectDateRange: 'Please select the date range for export and it  cannot be more than 60 days',
      idErrorHeader: `We're sorry, but something went wrong`,
      noReportDateError: "Please select a date for which you want the report",
      enterHowMuchUnitstoTransferout: 'To Transfer Out',
      currentHoldings: 'Current Holdings:',
      addBuyOrder: 'Add Buy Order',
      buyOrderAddedZpText: 'Buy order added successfully for ZP user',
      inProgressLabel: 'In-progress',
      ageOfRetirement: 'Age of Retirement',
      annualIncome: 'Annual Income',
      currentContribution: 'Current Contribution',
      requiredContribution: 'Required Contribution',
      targetNumbers: 'Target Numbers',
      expectedAt65: 'Expected at 65',
      currentGap: 'Current Gap',
      fundMatricesPercentage: 'Fund Matrices %',
      ageGroup: 'Age Group',
      equityText: 'Equity',
      bondText: 'Bond',
      cashText: 'Cash',
      dailyReportBuyLabel: 'Select an order filled date for which you want the BUY Orders report',
      dailyReportSellLabel: 'Select an order filled date for which you want the SELL Orders report',
      sameUserCantDelete: `Action not allowed: A user cannot delete their own account.`,
      allEmployeesExportSuccess: 'All Employees exported successfully!',
      allEmployeesExportFailed: 'Error in exporting All Employees!',
      customerDataExportSuccess: 'Customers data exported successfully!',
      customerDataExportError: 'Error in exporting customer data!',
      totalEmployees: 'Total Employees',
      orderslabel: 'Orders',
      fundChangeLabel: 'Fund Change',
      planChangeLabel: 'Plan Change',
      withdrawal: 'Withdrawal',
      rebalance: 'Rebalance',
      sale: 'Sale',
      mismtachDebtorName: 'Mismatch debtor name for organization',
      reAllocateUnits: 'Re-Allocate Units',
      reAllocateUnitsSuccess: 'Units reallocated successfully.',
      reAllocateUnitsFailed: 'Unit reallocation failed.',
      reAllocateUnitsError: 'Something went wrong during reallocation.',
      areYouConfirmReallocation: 'Are you sure want to confirm reallocation for the users?',
      previousERContribution: 'Previous ER Contribution',
      previousEEContribution: 'Previous EE Contribution',
      currentERContribution: 'Current ER Contribution',
      currentEEContribution: 'Current EE Contribution',
      diffERContribution: 'Difference ER Contribution',
      diffEEContribution: 'Difference EE Contribution',
      transferInRequestCreated: 'Transfer In request created successfully.',
      reconciledDate: 'Reconciled Date',
      publishedDate: 'Price Date',
      notboardedErrorType: 'notboarded',
      onboardingErrorType: 'onboarding',
      vestedAccountErrorType: 'vestedAccount',
      over65YearsErrorType: 'over65YearsOld',
      leaverErrorType: 'Leaver',
      vestedAccountContributionBlocked: 'This account is a Vested PRSA and cannot accept contributions.',
      employeeOver65YrsBlocked: 'This user is over 65 yrs old and cannot accept contributions.',
      leaverBlocked: 'This employee is a leaver of the organisation',
      removeAllNonOnboarded: 'Remove All Non-Onboarded',
      removeAllOver65Yrs: 'Remove All Over 65 Years Old',
      contributionFileDecimalError: 'Oops - some amounts use more than two decimal places. Please update them to two decimal places (for example, €123.45) and re-upload your file',
      verifyAddressInOnfido: 'Would you like to proceed with sending your data to Onfido for address verification?',
      onfidoRegistrationConfirmation: 'Are you sure you want to mark this user as registered for onfido?',
      verifyNameInOnfido: 'Would you like to verify the updated name on Onfido?',
      avcYesToNo1: 'Are you sure you want to change AVC pension details from Yes to No?',
      avcYesToNo2: 'This may remove or disable the existing AVC information.',
      avcNoToYes1: 'Are you sure you want to enable AVC pension details (No to Yes)?',
      avcNoToYes2: 'The user will need to provide additional AVC information after this change.',
      confirmAvcChange: 'Confirm AVC Pension Change',
      enterOrganizationIdUniqueId: 'Enter Organization ID/Unique ID',
      organizationIdUniqueId: 'Organization ID/Unique ID',
      contributionConfirmation: 'Are you sure you want to proceed with uploading contributions for',
      updateWatchlistStatus: 'Update Watchlist Status',
      updatePEPWatchlistStatus: 'Update PEP Watchlist Status',
      updateSanctionsWatchlistStatus: 'Update Sanctions Watchlist Status',
    },
  },
});

export const loginPageConst = {
  emailLabel: 'email',
};
